import TianDingAddressComponent from "./address.vue";

export default {
  install(Vue, PluginOptions = {}) {
    const Constructor = Vue.extend(TianDingAddressComponent);
    Vue.component('td-address', Constructor);
  }
}



// WEBPACK FOOTER //
// ./src/_components/address/index.js